export default {
  menu: [],
  table_rolbymenu:[],
  table_menu:[],
  table_rol:[],
  table_empresa:[],
  table_user:[],
}
